<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "EmptyLayout",
};
</script>

<style scoped>
div {
  min-height: 100vh;
}
</style>
